import {
    ODataHeader,
    ODataString,
    ODataBoolean,
    ODataDate
} from "pbas-vue-components";

const OrganizationsHeaders = [
    new ODataHeader({
        title: "ID",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        allowVisibilitychange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    /*{ text: 'Description', value: 'Description', 
        align: 'center',sortable: true,  
        visible: true, type:'string', 
        searchable:true },*/
    new ODataHeader({
        title: "components.vuematerialdashboard.core.appbar.users",
        type: new ODataString("Users[]/Email", {
            getHtml: (item, type) => {
                return ("<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
                    type.getString(item, type) +
                    "</div>");
            }
        }),
        sortable: false,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        title: "globals.plans",
        type: new ODataString("Plans[]/Name", {
            getHtml: (item, type) => {
                return ("<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
                    type.getString(item, type) +
                    "</div>");
            }
        }),
        sortable: false,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        title: "globals.active",
        type: new ODataBoolean("IsActive"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        type: new ODataBoolean("IsPrincipal"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    })
];
export default OrganizationsHeaders;